import { Box } from '@mui/material';
import {
  SearchableDropdown,
  SelectDropdown,
  type SelectDropdownOption,
} from '@peritasai/ui-components';
import React from 'react';
import { ItemGroupList } from './ItemGroupList';
import type { ItemGroupListProps } from './ItemGroupList';
import type { PreferenceCardItem } from './preference-card.types';

export interface CatalogOption {
  id: string;
  name: string;
  type: string;
}

export interface AssetsTabProps {
  searchValue: string;
  typeFilter: string;
  catalogOptions: CatalogOption[];
  isLoading: boolean;
  items: PreferenceCardItem[];
  groups: ItemGroupListProps['groups'];
  typeFilterOptions: SelectDropdownOption[];
  searchLabel: string;
  typeFilterLabel: string;
  minWidth?: number;
  onSearchChange: (value: string) => void;
  onTypeFilterChange: (value: string) => void;
  onAddItem: (catalogItemId: string, type: string, name: string) => void;
  onQuantityChange: (id: string, delta: number) => void;
  onNoteClick: (id: string, note: string) => void;
  onDelete: (id: string) => void;
}

export const AssetsTab: React.FC<AssetsTabProps> = ({
  searchValue, typeFilter, catalogOptions, isLoading, items, groups,
  typeFilterOptions, searchLabel, typeFilterLabel, minWidth = 120,
  onSearchChange, onTypeFilterChange, onAddItem, onQuantityChange, onNoteClick, onDelete,
}) => (
  <Box>
    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
      <SearchableDropdown
        sx={{ flex: 1 }}
        options={catalogOptions}
        getOptionLabel={(opt) => opt.name}
        value={null}
        inputValue={searchValue}
        loading={isLoading}
        label={searchLabel}
        onInputChange={onSearchChange}
        onChange={(value) => {
          if (value) {
            onAddItem(value.id, value.type, value.name);
            onSearchChange('');
          }
        }}
      />
      <SelectDropdown
        value={typeFilter}
        label={typeFilterLabel}
        options={typeFilterOptions}
        onChange={onTypeFilterChange}
        minWidth={minWidth}
      />
    </Box>
    <ItemGroupList
      items={items}
      groups={groups}
      onQuantityChange={onQuantityChange}
      onNoteClick={onNoteClick}
      onDelete={onDelete}
    />
  </Box>
);
